export class ActionButton {

    public caption: string;
    public iconName: string;
    public iconOverrideImagePath?: string;
    public actionName: string;
    public disabled: string;
    public isUnavailable: boolean;

    public constructor(caption: string, iconName: string, actionName: string, disabled: string = "", isUnavailable: boolean = false, iconOverrideImagePath?: string) {

        this.caption = caption;
        this.iconName = iconName;
        this.iconOverrideImagePath = iconOverrideImagePath;
        this.actionName = actionName;
        this.disabled = disabled;
        this.isUnavailable = isUnavailable;
    }
}
